export default __webpack_public_path__ + "static/media/cross.4489cbd5.svg";